import styled from 'styled-components';

import { token } from '@zillow/constellation';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

export const StyledContainer = styled.div`
    background-color: ${token('colors.gray200')};
`;

export const StyledSpinnerContainer = styled(SpinnerContainer)`
    min-height: 360px;
`;
